import { render, staticRenderFns } from "./jiedaiJiyang.vue?vue&type=template&id=5f65f99c&scoped=true&"
import script from "./jiedaiJiyang.vue?vue&type=script&lang=js&"
export * from "./jiedaiJiyang.vue?vue&type=script&lang=js&"
import style0 from "./jiedaiJiyang.vue?vue&type=style&index=0&id=5f65f99c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65f99c",
  null
  
)

export default component.exports